<template>
  <b-row>
    <b-col lg="12">
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .edu_program -->
            <b-col lg="4">
              <b-form-group
                id="input-group-2"
                :label="$t('edu_programs.edu_program')"
                label-for="input-2"
                ><validation-provider
                  #default="{ errors }"
                  name="eduProgram"
                  vid="eduProgram"
                  rules="required"
                >
                  <b-form-select
                    id="input-1"
                    v-model="newItem.edu_program_id"
                    :options="edu_program"
                    :state="errors.length > 0 ? false : null"
                    text-field="name"
                    value-field="id"
                    :placeholder="$t('edu_programs.edu_program')"
                    @input="changeEduProgram()"
                  ></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                id="input-group-2"
                :label="$t('certificates.certificates')"
                label-for="input-2"
                ><validation-provider
                  #default="{ errors }"
                  name="certificate"
                  vid="certificate"
                  rules="required"
                >
                  <b-form-select
                    id="input-1"
                    v-model="newItem.certificates"
                    :options="certificates"
                    :state="errors.length > 0 ? false : null"
                    text-field="name"
                    value-field="id"
                    :placeholder="$t('certificates.certificates')"
                  ></b-form-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col lg="4">
              <b-form-group
                id="input-group-2"
                :label="$t('certificates.certification_date')"
                label-for="input-2"
                ><validation-provider
                  #default="{ errors }"
                  name="certificate"
                  vid="certificate"
                  rules="required"
                >
                  <b-form-datepicker
                    id="example-datepicker"
                    v-model="certificate_date"
                    class="mb-1"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="12">
              <b-table :stacked="($mobile==1)"  :items="users" :fields="userfields">
                <template #cell(checkbox)="data">
                  <b-form-checkbox
                    v-model="usersSelelcted"
                    :value="data.item.id"
                  >
                  </b-form-checkbox>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
              >
            </b-col>
            <b-col lg="6">
              <b-button block @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import config from "@/config/config";
import EduProgramsController from "@/Controllers/EduProgramsController";
import controller from "@/Controllers/CertificationsController";

export default {
  components: { ValidationProvider, ValidationObserver, required },
  data() {
    return {
      file: {},
      newItem: {},
      
      edu_program: [],
      certificates: [],
      certificate_date: "",
      users: [],
      userfields: [
        { key: "checkbox", label: "", sortable: false },
        {
          key: "code",
          label: this.$i18n.t("students.academic_number"),
          sortable: true,
        },
        {
          key: "first_name",
          label: this.$i18n.t("students.first_name"),
          sortable: true,
        },
        {
          key: "last_name",
          label: this.$i18n.t("students.last_name"),
          sortable: true,
        },
        {
          key: "email",
          label: this.$i18n.t("users.email"),
          sortable: true,
        },
      ],
    };
  },
  created() {
    new EduProgramsController().GetAll().then((res) => {
      this.edu_program = res;
    });
    new controller().GetAll().then((res) => {
      this.certificates = res;
    });
  },
  methods: {
    changeEduProgram() {
      //   this.users = new controller().CretificateStudents({
      //     program_type: "edu_program",
      //     program_id: this.newItem.edu_program_id,
      //   });
      new EduProgramsController()
        .GetUsers(this.newItem.edu_program_id)
        .then((res) => {
          this.users = res.students;
        });
    },
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {},
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
  },
};
</script>

<style>
</style>